import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DEPOT_PASS_FUT_DOC',
  title: 'Wie legt man ein vergangenes oder zukünftiges Dokument ab?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Über die Registerkarte "Dokumente"'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf das Dokument Ihrer Wahl'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie auf die Schaltfläche "Neue Version einstellen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_DEPOT_PASS_FUT_DOC/DE_DEPOT_PASS_FUT_DOC.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Fahren Sie dann mit dem Hochladen Ihres Dokuments fort'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Wenn es sich um ein vergangenes Dokument handelt, wird es nach der Bearbeitung durch unsere Teams zu Ihrem Archiv hinzugefügt.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Wenn es sich um ein zukünftiges Dokument handelt, wird es zu Ihrem "aktuellen" Dokument hinzugefügt oder ersetzt es, sobald es gültig wird.'
  }]
};
